var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-treeview',{ref:"field_treeview",attrs:{"activatable":"","item-key":"id","items":_vm.fields,"active":_vm.selected_field},on:{"update:active":function($event){return _vm.$emit('update_selected_field', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }